import {
  Box,
  Divider,
  Stack,
  StackProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import { ReactNode } from "react";

type Props = {
  title: ReactNode;
  value: ReactNode;
  color?: TypographyProps["color"];
  divider?: boolean;
  hideNullable?: boolean;
  slotProps?: {
    title?: TypographyProps;
    value?: TypographyProps;
  };
};

export type ContractDetailItemProps = Props & Omit<StackProps, "divider">;

export const ContractDetailItem = ({
  title,
  value,
  color,
  divider,
  slotProps,
  hideNullable,
  ...props
}: ContractDetailItemProps) => {
  if (value === undefined || value === null) {
    if (hideNullable) {
      return divider ? (
        <Box py={2}>
          <Divider />
        </Box>
      ) : null;
    }
  }
  return (
    <Stack spacing={2}>
      <Stack direction="row" gap={2} {...props} width="auto" flex="0 0 auto">
        <Typography
          sx={{ wordBreak: "keep-all", whiteSpace: "nowrap" }}
          fontSize="small"
          variant="button"
          color="text.secondary"
          {...slotProps?.title}
        >
          {title}
        </Typography>
        <Typography
          color={color}
          fontSize="small"
          variant="button"
          fontWeight={600}
          textAlign="right"
          title={typeof value === "string" ? value : undefined}
          textOverflow="ellipsis"
          sx={{ wordBreak: "keep-all", whiteSpace: "nowrap" }}
          overflow="hidden"
          {...slotProps?.value}
        >
          {value ?? "N/A"}
        </Typography>
      </Stack>
      {divider && (
        <Box pb={2}>
          <Divider />
        </Box>
      )}
    </Stack>
  );
};
